<template>
  <v-dialog
      v-model="dialog"
  >
    <v-card elevation="0">
      <v-col class="text-right px-4">
        <v-btn icon @click="dialog=false">
          <v-icon large color="primary">close</v-icon>
        </v-btn>
      </v-col>
      <v-container v-if="dialog">
        <v-row justify="space-around">
          <v-col cols="12" md="5">
            <v-text-field
                outlined
                v-model="rest.name"
                :label="$t('common:name')"
            />

            <v-textarea
                outlined
                v-model="rest.description"
                :label="$t('common:description')"
                auto-grow
            />

            <v-text-field
                outlined
                v-model="rest.username"
                :label="$t('common:username')"
            />

            <v-text-field
                outlined
                v-model="rest.userpassword"
                :label="$t('common:password')"
            />

            <v-text-field
                outlined
                v-model="rest.token"
                :label="$t('settings/settings:rest.token')"
            />

            <v-text-field
                outlined
                v-model="rest.webpage"
                :label="$t('settings/settings:rest.webpage')"
            />

            <v-text-field
                outlined
                v-model="rest.client"
                :label="$t('settings/settings:rest.client')"
            />

            <v-checkbox
              v-model="rest.tokenRequired"
              :label="$t('settings/settings:rest.token-required')" />

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card
                elevation="0"
                flat
                tile
                class="pl-3 pt-3 pb-md-3"
            >
              <TwoButtonDialog
                  ref="saveButton"
                  :btn-text="$t('buttons:save')"
                  color="primary"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:save-btn-title', {name : $t('settings/settings:rest.rest') })"
                  :dialog-text="$t('dialog:save-btn-dialog', {name : $t('settings/settings:rest.rest') })"
                  :button1-text="$t('buttons:save')"
                  :button2-text="$t('buttons:cancel')"
                  @clickedButton1="updateForm()"
                  @clickedButton2="$refs.saveButton.showDialog = false"
              />
              <DirtyConfirmButtonDialog
                  ref="dirtyDialog"
                  :btn-text="$t('buttons:back')"
                  color="grey"
                  :hideOverlay="true"
                  :dialog-title="$t('dialog:save-btn-title')"
                  :dialog-text="$t('dialog:save-btn-dialog')"
                  :button1-text="$t('dialog:dirty-save-btn-1-text')"
                  :button2-text="$t('dialog:dirty-save-btn-2-text')"
                  @clickedButton="dialog=false"
              />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>

import DirtyConfirmButtonDialog from '@/modules/core/components/TwoButtonDialog/DirtyConfirmButtonDialog';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import RestService from '@/modules/settings/services/rest-service';
import Utils from '@/modules/core/services/utils';

export default {
  name: "RestExternalForm",
  components: {
    DirtyConfirmButtonDialog,
    TwoButtonDialog
  },
  data() {
    return {
      rest: {},
      dialog: false,
      edit: false
    }
  },
  methods: {
    updateForm() {
      this.dialog = false;
      this.rest.tokenRequired = this.rest.tokenRequired ? 1 : 0;
      RestService.saveRestExternal(
          this.rest,
          () => {
            if (!this.edit) {
              Utils.showSuccessSnackbar(this.$t('snackbar:add-success', {name: this.$t('settings/settings:rest.rest')}));
            } else {
              Utils.showSuccessSnackbar(this.$t('snackbar:edit-success', {name: this.$t('settings/settings:rest.rest')}));
            }

            this.$emit('updateTable');
          },
          () => {
            if (!this.edit) {
              Utils.showFailureSnackbar(this.$t('snackbar:add-failure', {name: this.$t('settings/settings:rest.rest')}));
            } else {
              Utils.showFailureSnackbar(this.$t('snackbar:edit-failure', {name: this.$t('settings/settings:rest.rest')}));
            }
          }
      )
    },
    initialization(item) {
      this.rest = {};
      this.edit = false;

      if (typeof item !== 'undefined' && typeof item.id !== 'undefined') {
        this.rest = item;
        this.edit = true;
      }

      this.dialog = true;
    }
  }
}
</script>
